import React from 'react';
import { createIcon } from './create-icon';
import './icon-save.scss';

export const IconSave = createIcon(<div className="icon-save" />);
